import React, { useEffect, useState } from "react";
import "./Numbers.css";

const OurNumbers = () => {
  const [numbers, setNumbers] = useState([]);

  const SHEET_URL = "https://docs.google.com/spreadsheets/d/e/2PACX-1vR_llBY1L7ImN2sss-oQNB4j_EiZtTggybT-s_FqKXjS29i6g_RsrwQz08xp-pi0bCOXHoB9RRZLYCA/pub?output=csv"; // replace with actual

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((csvText) => {
        const lines = csvText.split("\n").slice(1); // skip header
        const data = lines.map((line) => {
          const [number, title] = line.split(",");
          return { number, title };
        });
        setNumbers(data);
      })
      .catch((err) => console.error("Error loading metrics:", err));
  }, []);

  return (
    <section className="our-numbers-section">
      <h2 className="section-heading">Our Journey in Numbers</h2>
      <div className="numbers-grid">
        {numbers.map((item, idx) => (
          <div key={idx} className="number-card">
            <h1>{item.number}</h1>
            <p>{item.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurNumbers;
